import { ColorFinderImage } from "@nova/protobuf"
import {
    blankValidator,
    booleanValidator,
    entityValidator,
    idValidators,
    latitudeValidators,
    longitudeValidators,
    UnionToTuple,
} from "../util"

export const createColorFinderImageValidator = entityValidator(ColorFinderImage, {
    // prototodo: review this
    id: { validators: idValidators, nonNull: true },
    longitude: { validators: longitudeValidators, nonNull: true },
    latitude: { validators: latitudeValidators, nonNull: true },
    altitude: { validators: blankValidator, nonNull: true },
    height: { validators: blankValidator },
    pitch: { validators: blankValidator },
    yaw: { validators: blankValidator },
    roll: { validators: blankValidator },
    hasLowQuality: { validators: booleanValidator("hasLowQuality"), nonNull: true },
    takenAt: { validators: blankValidator, nonNull: true },
    fov: { validators: blankValidator, nonNull: true },
    make: { validators: [] },
    focalLength: { validators: [] },
    size: { validators: [], nonNull: true },
    uploadedAt: { validators: [], nonNull: true },
})

export const updateColorFinderImageValidator = entityValidator(ColorFinderImage, {})

export const getDefaultColorFinderImageCreateArgs = () => ({
    colorData: new Uint8Array(0),
})

export type CreateColorFinderImageArgs = UnionToTuple<keyof typeof createColorFinderImageValidator>
export type UpdateColorFinderImageArgs = UnionToTuple<keyof typeof updateColorFinderImageValidator>
